var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgJozunaExpandedLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 172,
    height: 64,
    viewBox: "0 0 172 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M159.307 0H12.238C5.47915 0 0 5.47915 0 12.238V51.762C0 58.5209 5.47915 64 12.238 64H159.307C166.066 64 171.545 58.5209 171.545 51.762V12.238C171.545 5.47915 166.066 0 159.307 0Z",
    fill: "#424242"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M159.307 2.05854C164.92 2.05854 169.486 6.62507 169.486 12.238V51.7586C169.486 57.3715 164.92 61.938 159.307 61.938H12.238C6.62507 61.938 2.05854 57.3715 2.05854 51.7586V12.238C2.05854 6.62507 6.62507 2.05854 12.238 2.05854H159.304M159.307 0H12.238C5.47915 0 0 5.47915 0 12.238V51.7586C0 58.5174 5.47915 63.9966 12.238 63.9966H159.304C166.062 63.9966 171.542 58.5174 171.542 51.7586V12.238C171.542 5.47915 166.062 0 159.304 0H159.307Z",
    fill: "url(#paint0_linear_462_1670)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M58.4866 18.3967H78.3309V22.3663L66.8202 37.747H78.3309V43.2056H58.4866V39.236L70.0453 23.8553H58.4866V18.3967Z",
    fill: "url(#paint1_linear_462_1670)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M91.9756 43.6482C89.924 43.6482 88.1811 43.3085 86.7401 42.6326C85.3025 41.9567 84.1189 41.0956 83.1925 40.0526C82.2662 39.0096 81.5972 37.8774 81.182 36.6525C80.7669 35.4277 80.561 34.2715 80.561 33.1805V18.3967H86.5136V33.0329C86.5136 33.9284 86.6612 34.6866 86.9597 35.3145C87.2582 35.9424 87.6527 36.4741 88.1502 36.903C88.6477 37.3319 89.2241 37.6475 89.8862 37.8465C90.5484 38.0455 91.2414 38.145 91.9688 38.145C92.6961 38.145 93.3892 38.0455 94.0513 37.8465C94.7135 37.6475 95.2933 37.3353 95.7874 36.903C96.2849 36.4741 96.6794 35.9458 96.9779 35.3145C97.2764 34.6866 97.4239 33.925 97.4239 33.0329V18.3967H103.377V33.1805C103.377 34.2715 103.171 35.4311 102.756 36.6525C102.34 37.8774 101.671 39.0096 100.745 40.0526C99.8187 41.0956 98.635 41.9533 97.1975 42.6326C95.7599 43.3085 94.0136 43.6482 91.9619 43.6482H91.9756Z",
    fill: "url(#paint2_linear_462_1670)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M117.028 17.9507C119.08 17.9507 120.822 18.2903 122.263 18.9662C123.701 19.6455 124.885 20.5033 125.811 21.5463C126.737 22.5893 127.406 23.7215 127.821 24.9463C128.233 26.1711 128.442 27.3273 128.442 28.4184V43.2021H122.49V28.5659C122.49 27.6739 122.342 26.9122 122.044 26.2843C121.745 25.6565 121.351 25.1281 120.853 24.6958C120.356 24.267 119.779 23.9513 119.117 23.7523C118.455 23.5533 117.762 23.4538 117.035 23.4538C116.307 23.4538 115.611 23.5533 114.952 23.7523C114.29 23.9513 113.71 24.267 113.216 24.6958C112.719 25.1247 112.324 25.6565 112.026 26.2843C111.727 26.9122 111.58 27.6739 111.58 28.5659V43.2021H105.627V28.4184C105.627 27.3273 105.833 26.1711 106.248 24.9463C106.66 23.7249 107.332 22.5893 108.258 21.5463C109.185 20.5033 110.368 19.6455 111.806 18.9662C113.244 18.2903 114.99 17.9507 117.038 17.9507H117.028Z",
    fill: "url(#paint3_linear_462_1670)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M143.47 18.0503C145.388 18.0503 147.141 18.3557 148.729 18.9698C150.318 19.5805 151.673 20.4485 152.798 21.5738C153.924 22.6992 154.792 24.0544 155.403 25.6429C156.013 27.2314 156.322 28.9846 156.322 30.9025V43.2057H150.369V40.8246C149.772 41.5863 148.856 42.2484 147.614 42.8077C146.372 43.3669 144.842 43.6517 143.024 43.6517C141.205 43.6517 139.583 43.3463 138.063 42.7322C136.543 42.1215 135.236 41.2535 134.145 40.1281C133.054 39.0028 132.203 37.6476 131.589 36.0591C130.978 34.4706 130.673 32.7174 130.673 30.7995C130.673 28.8817 130.978 27.1353 131.589 25.564C132.199 23.9926 133.067 22.6546 134.193 21.5464C135.318 20.4382 136.666 19.5805 138.238 18.9664C139.809 18.3557 141.552 18.0469 143.473 18.0469L143.47 18.0503ZM150.366 30.851C150.366 28.5351 149.745 26.7339 148.506 25.4439C147.264 24.1539 145.604 23.5089 143.521 23.5089C141.439 23.5089 139.768 24.1539 138.512 25.4439C137.257 26.7339 136.629 28.5386 136.629 30.851C136.629 33.1634 137.257 34.9681 138.512 36.2581C139.768 37.5481 141.439 38.1931 143.521 38.1931C145.604 38.1931 147.268 37.5481 148.506 36.2581C149.748 34.9681 150.366 33.1669 150.366 30.851Z",
    fill: "url(#paint4_linear_462_1670)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M19.2439 18.3966H25.1965V45.6345C25.1965 46.9897 25.0558 48.2626 24.7745 49.4531C24.4932 50.6436 24.006 51.6935 23.3095 52.6027C22.6165 53.5118 21.6901 54.2323 20.5305 54.7607C19.3743 55.289 17.9161 55.5532 16.1664 55.5532H15.6964C15.5488 55.5532 15.391 55.5361 15.2263 55.5018V50.0432C16.482 50.0432 17.4667 49.6795 18.1769 48.9522C18.8871 48.2248 19.2439 47.0171 19.2439 45.3291V18.3966ZM18.6984 11.2535C18.6984 10.2619 19.0449 9.41792 19.7414 8.72488C20.4379 8.03184 21.2613 7.68188 22.2219 7.68188C23.1826 7.68188 24.0506 8.02841 24.7265 8.72488C25.4024 9.41792 25.742 10.2619 25.742 11.2535C25.742 12.245 25.4024 13.089 24.7265 13.782C24.0472 14.4751 23.2135 14.825 22.2219 14.825C21.2304 14.825 20.4344 14.4785 19.7414 13.782C19.0483 13.089 18.6984 12.245 18.6984 11.2535Z",
    fill: "url(#paint5_linear_462_1670)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M29.7012 35.6884C29.7012 32.4633 30.9569 29.4338 33.235 27.1523C35.5166 24.8707 38.5461 23.6185 41.7711 23.6185C44.9961 23.6185 48.0256 24.8742 50.3072 27.1523C52.5887 29.4338 53.841 32.4633 53.841 35.6884C53.841 37.2494 53.5459 38.7659 52.9833 40.176C55.1001 37.644 56.373 34.3812 56.373 30.8233C56.373 22.7573 49.8371 16.2214 41.7711 16.2214C33.7051 16.2214 27.1692 22.7573 27.1692 30.8233C27.1692 34.3812 28.4421 37.644 30.5589 40.176C29.9962 38.7693 29.7012 37.2528 29.7012 35.6884Z",
    fill: "url(#paint6_linear_462_1670)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M41.771 45.4251C44.4598 45.4251 46.6395 43.2454 46.6395 40.5567C46.6395 37.8679 44.4598 35.6882 41.771 35.6882C39.0823 35.6882 36.9026 37.8679 36.9026 40.5567C36.9026 43.2454 39.0823 45.4251 41.771 45.4251Z",
    fill: "url(#paint7_linear_462_1670)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M34.5696 40.5567C34.5696 36.5837 37.8015 33.3518 41.7745 33.3518C45.7475 33.3518 48.9794 36.5837 48.9794 40.5567C48.9794 41.2395 48.8833 41.9016 48.7015 42.5295C50.4375 40.7729 51.5079 38.3575 51.5079 35.6917C51.5079 30.3155 47.1507 25.9583 41.7745 25.9583C36.3983 25.9583 32.041 30.3155 32.041 35.6917C32.041 38.3575 33.1115 40.7729 34.8475 42.5295C34.6691 41.9016 34.5696 41.2429 34.5696 40.5567Z",
    fill: "url(#paint8_linear_462_1670)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M41.771 45.4251C44.4598 45.4251 46.6395 43.2454 46.6395 40.5567C46.6395 37.8679 44.4598 35.6882 41.771 35.6882C39.0823 35.6882 36.9026 37.8679 36.9026 40.5567C36.9026 43.2454 39.0823 45.4251 41.771 45.4251Z",
    fill: "url(#paint9_linear_462_1670)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_462_1670",
    x1: 0,
    y1: 32,
    x2: 171.545,
    y2: 32,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ECC440"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#FFFA8A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#DDAC17"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFFF95"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_462_1670",
    x1: 58.4866,
    y1: 30.7994,
    x2: 78.3309,
    y2: 30.7994,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ECC440"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#FFFA8A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#DDAC17"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFFF95"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_462_1670",
    x1: 80.5645,
    y1: 31.0224,
    x2: 103.387,
    y2: 31.0224,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ECC440"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#FFFA8A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#DDAC17"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFFF95"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_462_1670",
    x1: 105.617,
    y1: 30.5764,
    x2: 128.439,
    y2: 30.5764,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ECC440"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#FFFA8A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#DDAC17"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFFF95"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_462_1670",
    x1: 130.669,
    y1: 30.851,
    x2: 156.319,
    y2: 30.851,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ECC440"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#FFFA8A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#DDAC17"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFFF95"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_462_1670",
    x1: 15.2263,
    y1: 31.6193,
    x2: 25.742,
    y2: 31.6193,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ECC440"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#FFFA8A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#DDAC17"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFFF95"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_462_1670",
    x1: 27.1692,
    y1: 28.1953,
    x2: 56.373,
    y2: 28.1953,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ECC440"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#FFFA8A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#DDAC17"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFFF95"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_462_1670",
    x1: 36.906,
    y1: 40.5567,
    x2: 46.6395,
    y2: 40.5567,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ECC440"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#FFFA8A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#DDAC17"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFFF95"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_462_1670",
    x1: 32.0376,
    y1: 34.2404,
    x2: 51.5079,
    y2: 34.2404,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ECC440"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#FFFA8A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#DDAC17"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFFF95"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_462_1670",
    x1: 36.906,
    y1: 40.5567,
    x2: 46.6395,
    y2: 40.5567,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ECC440"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#FFFA8A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#DDAC17"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFFF95"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJozunaExpandedLogo);
export default __webpack_public_path__ + "static/media/jozunaExpandedLogo.cf3dd8811dc5516cdaa90cf612a0e7e5.svg";
export { ForwardRef as ReactComponent };